module.exports = __webpack_public_path__ + "img/img01.4f55046f.png";